export default "__VITE_ASSET__UaCatLFX__"